module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', {
    staticClass: "item button-publish bt-copy_url"
  }, [_c('a', {
    staticClass: "kp-modular-publish animate-in",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": function($event) {
        return _vm.boxSave(true)
      }
    }
  }, [_c('i', {
    staticClass: "kp-panel-publish"
  }), _vm._v(" "), _c('span', {
    staticClass: "txt"
  }, [_vm._v(_vm._s(_vm.$t('general.actions.publish')))])])])
},staticRenderFns: []}


/*****************
 ** WEBPACK FOOTER
 ** ./~/vue-loader/lib/template-compiler.js?id=data-v-248e0a04!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/edit/topbar/buttons/Publish.vue
 ** module id = 781
 ** module chunks = 1
 **/